import { extractErrorMessage } from '@/hooks/useErrorNotification';

import Alert from '@mui/material/Alert';

export default function ErrorAlert({ error }: { error: unknown }) {
  return <Alert severity="error">{extractErrorMessage(error)}</Alert>;
}
